<template>
  <div v-if="isFreePlan">
    <v-row>
      <v-col>
        <v-alert color="accent">
          Your free trial will expire on {{ billing.expireAt | fmtDate }}
        </v-alert>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-switch
          v-model="billedAnnually"
          :label="billedAnnually ? 'Billed Annually' : 'Billed Monthly'"
          color="primary"
          class="justify-center"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        md="6"
        offset-md="3"
        lg="4"
        offset-lg="4"
      >
        <v-card>
          <v-card-title class="justify-center">
            Basic
          </v-card-title>

          <v-card-text>
            <div class="title text-center">
              € {{ billedAnnually ? 15 : 19 }}
              <small> / user / month</small>
            </div>
          </v-card-text>

          <v-card-actions class="justify-center">
            <v-btn
              depressed
              color="primary"
              @click="redirectToCheckout"
            >
              Upgrade
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>

  <v-row v-else>
    <v-col>
      <v-col
        cols="12"
        md="6"
        offset-md="3"
        lg="4"
        offset-lg="4"
      >
        <v-card>
          <v-card-title class="justify-center">
            You are on the {{ billing.plan }} plan
          </v-card-title>

          <v-card-text>
            Your next invoice is on {{ billing.expireAt | fmtDate }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-col>
  </v-row>
</template>

<script>
/* global Stripe */
import { BSON } from 'mongodb-stitch-browser-sdk'

import config from '@/config'
import { db, client } from '@/plugins/stitch'

export default {
  data () {
    return {
      billedAnnually: true,
      billing: {},
      card: null,
      error: null,
      stripe: null
    }
  },
  computed: {
    isFreePlan () {
      return !this.billing ||
        !this.billing.plan ||
        this.billing.plan === 'free'
    }
  },
  async mounted () {
    this.waitForStripe()

    this.billing = await db
      .collection('billing')
      .findOne({ _id: new BSON.ObjectId(this.$currentUser.id) })
  },
  methods: {
    init () {
      this.stripe = Stripe(config.stripeApiKey)
    },
    async redirectToCheckout () {
      const session = await client.callFunction('stripeCreateSession', [1, this.billedAnnually])

      const { error } = await this.stripe.redirectToCheckout({
        sessionId: session.id
      })

      throw new Error(error)
    },
    waitForStripe () {
      if (Stripe) {
        this.init()
      } else {
        this.timeout = setTimeout(this.waitForStripe, 500)
      }
    }
  }
}
</script>

<style>
.StripeElement {
  background-color: white;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #f44336;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
